import { chain } from "lodash"

const sagas = chain(require.context(".", false, /.js/).keys())
  .map(id => require(`${id}`).saga)
  .filter(saga => !!saga)
  .value()

export default sagas
